import { buildUrl } from "cloudinary-build-url";

interface IGetImageUrlParams {
  src: string;
}

export const getImageUrl = ({ src }: IGetImageUrlParams) => {
  const url = buildUrl(src, {
    cloud: {
      cloudName: "oriolpuig",
    },
  });

  return url;
};
